import React from "react";
import { injectIntl } from "react-intl";
import Propertii from "../../common/Propertii";
import PaymentMethodAuditReport from "../../common/ReportPaymentMethodAudit";

class ReportPaymentMethodAudit extends Propertii {

    /**
     * Render the component.
     *
     * @returns {*} - The company complete transactions report component.
     */
    render() {

        return(
            <PaymentMethodAuditReport companyId={this.props.match.params.companyId} />
        )
    };
}

export default injectIntl(ReportPaymentMethodAudit);